import {
  PERFIL_POR_ROLE,
  escopoDoRole,
  perfilDoRole,
  temAcesso
} from "./perfilPorRole";

/* O que estes testes protegem é o CASAMENTO com o backend, não o formato do
   objeto. Quem decide acesso de verdade é EscopoAnalyticsService::HIERARQUIA
   (G, U, R, E, P) mais o piso `hasRole` de cada arquivo de rota; este mapa é o
   espelho disso no front. Quando os dois discordam o sintoma é mudo: ou um item
   de menu que leva a 403, ou — o caso que existiu até 04/08/2026 — um papel que
   o servidor liberava e o front escondia, sem erro em lugar nenhum.

   Papel -> type, conferido em access_roles (ava_homologa, 04/08/2026):
     1 G · 2 U · 3 R · 4 E · 5 E · 6 P · 7 A · 8 S · 9 V */

const papel = (roleId, extra = {}) => ({ role_id: roleId, ...extra });

describe("allowlist de papéis", () => {
  it("libera exatamente os papéis cujo type o backend aceita", () => {
    expect(Object.keys(PERFIL_POR_ROLE).map(Number).sort()).toEqual([
      1, 2, 3, 4, 5, 6
    ]);
  });

  it("nega estudante, responsável e visitante", () => {
    // Não é preferência de produto: type A, S e V estão fora da HIERARQUIA do
    // EscopoAnalyticsService, então toda rota responderia 403.
    [7, 8, 9].forEach(roleId => {
      expect(PERFIL_POR_ROLE[roleId]).toBeUndefined();
      expect(temAcesso(roleId)).toBe(false);
      expect(perfilDoRole(roleId)).toBeNull();
    });
  });
});

describe("Coordenador Pedagógico (papel 5)", () => {
  it("tem acesso ao painel", () => {
    expect(temAcesso(5)).toBe(true);
  });

  it("recebe o mesmo perfil e escopo do Administrador Escolar", () => {
    // Os dois têm type E: o backend dá a ambos o recorte de escola, e o front
    // não tem informação para distingui-los.
    expect(PERFIL_POR_ROLE[5]).toEqual(PERFIL_POR_ROLE[4]);
    expect(escopoDoRole(5)).toBe("escola");
    expect(perfilDoRole(5)).toBe("admin");
  });
});

/* --------------------------------------------------------------------------
   O papel ativo é o único que decide (decisão do Kilson, 04/08/2026)
   --------------------------------------------------------------------------
   O defeito: usuário com dois papéis (há caso real de Gestor de rede +
   Administrador escolar) recebia uma tela perguntando "por qual visão quer
   começar", e o painel somava os perfis de todos os papéis dele. Deve valer só
   o perfil em que ele está setado no AVA.

   Nada aqui recebe a lista de papéis do usuário, e essa ausência é a asserção
   mais importante do arquivo: não há por onde um segundo papel influenciar o
   que o usuário vê. */
describe("o perfil vem do papel ativo, e só dele", () => {
  it("dá um único perfil para cada papel, nunca uma lista", () => {
    expect(perfilDoRole(1)).toBe("gestor"); // Administrador Educandus
    expect(perfilDoRole(2)).toBe("gestor"); // Administrador do Grupo
    expect(perfilDoRole(3)).toBe("gestor"); // Administrador de Regional
    expect(perfilDoRole(4)).toBe("admin"); // Administrador Escolar
    expect(perfilDoRole(5)).toBe("admin"); // Coordenador Pedagógico
    expect(perfilDoRole(6)).toBe("professor"); // Professor
  });

  it("o Administrador Educandus entra no painel de rede, sem escolher", () => {
    // Era o único papel que sobrava sem perfil (`perfil: null` + escopo
    // "todos"), e o que mantinha a tela de seleção viva. É irrestrito no
    // backend, então abre a visão mais ampla das três.
    expect(perfilDoRole(1)).toBe("gestor");
    expect(escopoDoRole(1)).toBe("todos");
  });

  it("papel ativo sem acesso não é salvo por outro papel do usuário", () => {
    // Antes, temAcesso caía para user_roles e o item de menu aparecia para quem
    // estava no AVA como Estudante mas tinha papel de professor guardado.
    // Passar a lista de papéis não pode mudar a resposta — a assinatura só
    // aceita o papel ativo.
    expect(temAcesso(7, [papel(7), papel(5)])).toBe(false);
    expect(temAcesso(7, [papel(7), papel(2)])).toBe(false);
    expect(perfilDoRole(7)).toBeNull();
  });

  it("papel ativo elegível dá acesso mesmo sem lista de papéis", () => {
    expect(temAcesso(2)).toBe(true);
    expect(temAcesso(6)).toBe(true);
  });

  it("papel ativo ausente não tem perfil nem acesso", () => {
    expect(temAcesso(undefined)).toBe(false);
    expect(temAcesso(null)).toBe(false);
    expect(perfilDoRole(undefined)).toBeNull();
    expect(escopoDoRole(undefined)).toBeNull();
  });

  it("todo papel liberado tem perfil — nenhum cai em tela de escolha", () => {
    // A garantia estrutural: se algum dia um papel entrar no mapa com
    // `perfil: null`, o painel não teria para onde mandá-lo, e é assim que uma
    // tela de seleção voltaria pela porta dos fundos.
    Object.keys(PERFIL_POR_ROLE).forEach(roleId => {
      expect(["gestor", "admin", "professor"]).toContain(
        PERFIL_POR_ROLE[roleId].perfil
      );
    });
  });
});
